
/**
 * Loader API Version: 2
 * Is this in "webpack mode": true
 */
export default {
  "betaOptIn": "New Privacy Hero features! 1) Product and Feature Alert 2) Beta Firmware Program <a href='/account'>View Now</a> 3) NordVPN OpenVPN Support ",
}
